import "@Styles/Shared/ProductInfo/ImageCarousel/imageCarousel_sm.less";
import "@Styles/Shared/ProductInfo/ImageCarousel/imageCarousel_lg.less";
var imageModal = function imageModal() {
  return import(
  /* webpackChunkName: 'imageModal' */
  './imageModal');
};

export default {
  data: function data() {
    return {
      images: [],
      numberOfThumbnails: 0,
      thumbnailButtonText: '',
      thumbnailLabel: '',
      imageModalHeading: '',
      imageModalLabel: '',
      selectedIndex: 0,
      thumbnailImages: [],
      touchX: null,
      touchY: null,
      modalComponent: '',
      isModalVisible: false,
      screenSize: 0
    };
  },
  components: {
    'ImageModal': imageModal
  },
  computed: {
    selectedImage: function selectedImage() {
      if (this.selectedIndex >= 0 && this.selectedIndex < this.images.length) {
        return this.images[this.selectedIndex];
      } else {
        return {};
      }
    },
    imageThumbnails: function imageThumbnails() {
      if (this.images) {
        if (this.images.length > this.numberOfThumbnails && this.screenSize >= 1000) {
          return this.images.slice(0, this.numberOfThumbnails);
        } else {
          return this.images;
        }
      } else {
        return {};
      }
    },
    moreThumbnailsText: function moreThumbnailsText() {
      if (this.images && this.imageThumbnails && this.images.length > this.imageThumbnails.length) {
        var moreThumbnailsNumber = this.images.length - this.imageThumbnails.length;
        return this.thumbnailButtonText.replace('{0}', moreThumbnailsNumber.toString());
      } else {
        return '';
      }
    }
  },
  created: function created() {
    this.screenSize = window.innerWidth;
    window.addEventListener("resize", this.$_processScreenSize);
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.$_processScreenSize);
  },
  methods: {
    init: function init(config) {
      this.images = this.$_processImages(config);
      this.numberOfThumbnails = config.numberOfThumbnails;
      this.thumbnailButtonText = config.thumbnailButtonText;
      this.thumbnailLabel = config.thumbnailLabel;
      this.imageModalHeading = config.imageModalHeading;
      this.imageModalLabel = config.imageModalLabel;
    },
    previous: function previous() {
      this.selectImage(this.selectedIndex - 1);
    },
    next: function next() {
      this.selectImage(this.selectedIndex + 1);
    },
    selectImage: function selectImage(index) {
      if (index >= 0 && index < this.images.length) {
        // only change if index is in range
        this.selectedIndex = index;
      }
    },
    handleTouchStart: function handleTouchStart(event) {
      if (event && event.touches) {
        var firstTouch = event.touches[0];
        this.touchX = firstTouch.clientX;
        this.touchY = firstTouch.clientY;
      }
    },
    handleTouchMove: function handleTouchMove(event) {
      if (!event || !event.touches || !this.touchX || !this.touchY) {
        return;
      }

      var xDiff = this.touchX - event.touches[0].clientX;
      var yDiff = this.touchY - event.touches[0].clientY;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (xDiff > 0) {
          // left swipe
          this.next();
        } else {
          // right swipe
          this.previous();
        }
      } // reset for next touch event


      this.touchX = null;
      this.touchY = null;
    },
    setModalComponent: function setModalComponent(modalName) {
      if (this.screenSize >= 1000) {
        this.modalComponent = modalName;
        this.isModalVisible = true;
      }
    },
    hideModal: function hideModal() {
      this.isModalVisible = false;
    },
    $_processImages: function $_processImages(config) {
      var _this = this;

      if (config && config.images && config.imageUrlType && config.transformQueryParameter) {
        var imgType = config.imageUrlType;
        var images = config.images.map(function (img) {
          if (img.url.indexOf("https://res.cloudinary.com/general-mills/image/upload/") == 0) {
            return {
              desktop: img.url.replace(imgType, imgType + config.cloudinaryDesktopImageWidthUrlTransform),
              tablet: img.url.replace(imgType, imgType + config.cloudinaryTabletImageWidthUrlTransform),
              mobile: img.url.replace(imgType, imgType + config.cloudinaryMobileImageWidthUrlTransform),
              thumbnail: img.url.replace(imgType, imgType + config.cloudinaryThumbnailImageWidthUrlTransform),
              altText: img.altText
            };
          } else if (img.url.includes("/-/media/GMI/Core-Sites")) {
            return {
              desktop: img.url.replace("?W=", "&W=").concat("&", config.transformQueryParameter, "=", config.desktopImageWidthUrlTransform),
              tablet: img.url.replace("?W=", "&W=").concat("&", config.transformQueryParameter, "=", config.tabletImageWidthUrlTransform),
              mobile: img.url.replace("?W=", "&W=").concat("&", config.transformQueryParameter, "=", config.mobileImageWidthUrlTransform),
              thumbnail: img.url.replace("?W=", "&W=").concat("&", config.transformQueryParameter, "=", config.thumbnailImageWidthUrlTransform),
              altText: img.altText
            };
          } else {
            return {
              desktop: _this.$_transformImageUrl(img.url, config.transformQueryParameter, config.desktopImageWidthUrlTransform),
              tablet: _this.$_transformImageUrl(img.url, config.transformQueryParameter, config.tabletImageWidthUrlTransform),
              mobile: _this.$_transformImageUrl(img.url, config.transformQueryParameter, config.mobileImageWidthUrlTransform),
              thumbnail: _this.$_transformImageUrl(img.url, config.transformQueryParameter, config.thumbnailImageWidthUrlTransform),
              altText: img.altText
            };
          }
        });
        return images;
      } else {
        return [];
      }
    },
    $_processScreenSize: function $_processScreenSize(e) {
      if (e && e.target) {
        this.screenSize = e.target.innerWidth;
      }
    },
    $_transformImageUrl: function $_transformImageUrl(imgUrl, tranformQueryParameter, imageWidthUrlTransform) {
      var url = new URL(imgUrl);
      var queryStringParameters = new URLSearchParams(url.search);

      if (queryStringParameters.has(tranformQueryParameter)) {
        queryStringParameters.set(tranformQueryParameter, imageWidthUrlTransform);
        url.search = queryStringParameters.toString();
      }

      return url.toString();
    }
  }
};